const styles = {
  banner: {
    backgroundColor: "#f2f3ff",
    px: 3,
    py: 2,
    borderRadius: 4,
    mb: 3,
    alignItems: "center",
    gap: 2,
  },
  button: {
    color: "purple.main",
    borderRadius: 2,
    borderColor: "purple.main",
    fontSize: { xs: 12, md: 14 },
    px: 3,
    py: 1,
  },
};

export default styles;
